import React from 'react';
import { Auth0Provider, AppState } from '@auth0/auth0-react';
import { useHistory } from 'react-router-dom';
import config from '../../../../config';
import { Auth0PendoIdentifyAnalytics } from './Auth0PendoAnalytics';

const Auth0Wrapper = ({ children }: { children: React.ReactNode }) => {
  const history = useHistory();

  const onRedirectCallback = (appState?: AppState | undefined) => {
    history.push(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={config.auth0.domain}
      clientId={config.auth0.clientId}
      authorizationParams={{ redirect_uri: window.location.origin, audience: config.patientWebServiceBaseUrl }}
      onRedirectCallback={onRedirectCallback}
    >
      <Auth0PendoIdentifyAnalytics>{children}</Auth0PendoIdentifyAnalytics>
    </Auth0Provider>
  );
};

export default Auth0Wrapper;
